import React from 'react'
import ArticleList from './article-list'
import './showmore-button.css'
import { url } from '../api.config'

class Home extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loaded: 0,
            results: [],
            showMoreButton: true
        }
    }
    componentDidMount() {
        fetch(url + '/list?skip=0&limit=20')
            .then((response) => {
                return response.json()
            })
            .then((result) => {
                this.setState({
                    results: result,
                    loaded: 20
                })
            });
    }

    showMore = () => {
        fetch(url + '/list?skip=' + this.state.loaded + '&limit=20')
            .then((response) => {
                return response.json();
            })
            .then((result) => {
                if (result.length === 0) {
                    this.setState({ showMoreButton: false })
                } else {
                    this.setState({ results: this.state.results.concat(result) })
                    this.setState({ loaded: this.state.loaded + 20 })
                }
            });
    }

    render() {
        return (
            <div className='main'>
                <div className='header'>
                    <div className='logo'></div>
                    <div className='page-title'>
                        <h1>Home</h1>
                        <p>ホーム</p>
                    </div>
                </div>
                <div className='page'>
                    <ArticleList
                        results={this.state.results}
                    />
                    <div className='showmore-button' onClick={this.showMore} style={{ display: this.state.showMoreButton ? '' : 'none' }}>もっと見る</div>
                </div>
            </div >
        )
    }
}

export default Home
